export const FETCH_WORKKARD_OWNER_LIST_REQUEST = 'FETCH_WORKKARD_OWNER_LIST_REQUEST';
export const FETCH_WORKKARD_OWNER_LIST_REQUEST_SUCCESS = 'FETCH_WORKKARD_OWNER_LIST_REQUEST_SUCCESS';
export const FETCH_WORKKARD_OWNER_LIST_REQUEST_ERROR = 'FETCH_WORKKARD_OWNER_LIST_REQUEST_ERROR';

export const CHANGE_WORKKARD_OWNER_REQUEST = 'CHANGE_WORKKARD_OWNER_REQUEST';
export const CHANGE_WORKKARD_OWNER_REQUEST_SUCCESS = 'CHANGE_WORKKARD_OWNER_REQUEST_SUCCESS';
export const CHANGE_WORKKARD_OWNER_RESET_TO_INITIAL_STATE = 'CHANGE_WORKKARD_OWNER_RESET_TO_INITIAL_STATE';
export const CHANGE_WORKKARD_OWNER_REQUEST_ERROR = 'CHANGE_WORKKARD_OWNER_REQUEST_ERROR';

export const BULK_VALIDATE_WORKKARD_IDS_CHANGE_OWNER_REQUEST = 'BULK_VALIDATE_WORKKARD_IDS_CHANGE_OWNER_REQUEST'
export const BULK_VALIDATE_WORKKARD_IDS_CHANGE_OWNER_REQUEST_SUCCESS = 'BULK_VALIDATE_WORKKARD_IDS_CHANGE_OWNER_REQUEST_SUCCESS'
export const BULK_VALIDATE_WORKKARD_IDS_CHANGE_OWNER_REQUEST_ERROR = 'BULK_VALIDATE_WORKKARD_IDS_CHANGE_OWNER_REQUEST_ERROR'

export const FETCH_ACTIVITY_OWNER_LIST_REQUEST = 'FETCH_ACTIVITY_OWNER_LIST_REQUEST'; //fetch change owner dialogue content
export const FETCH_ACTIVITY_OWNER_LIST_REQUEST_SUCCESS = 'FETCH_ACTIVITY_OWNER_LIST_REQUEST_SUCCESS'
export const FETCH_ACTIVITY_OWNER_LIST_REQUEST_ERROR = 'FETCH_ACTIVITY_OWNER_LIST_REQUEST_ERROR'


export const CHANGE_ACTIVITY_OWNER_REQUEST = 'CHANGE_ACTIVITY_OWNER_REQUEST';
export const CHANGE_ACTIVITY_OWNER_REQUEST_SUCCESS = 'CHANGE_ACTIVITY_OWNER_REQUEST_SUCCESS';
export const CHANGE_ACTIVITY_OWNER_RESET_TO_INITIAL_STATE = 'CHANGE_ACTIVITY_OWNER_RESET_TO_INITIAL_STATE';
export const CHANGE_ACTIVITY_OWNER_REQUEST_ERROR = 'CHANGE_ACTIVITY_OWNER_REQUEST_ERROR';

// change activity owner
export const BULK_VALIDATE_ACTIVITY_IDS_CHANGE_OWNER_REQUEST = 'BULK_VALIDATE_ACTIVITY_IDS_CHANGE_OWNER_REQUEST';
export const BULK_VALIDATE_ACTIVITY_IDS_CHANGE_OWNER_REQUEST_SUCCESS = 'BULK_VALIDATE_ACTIVITY_IDS_CHANGE_OWNER_REQUEST_SUCCESS';

export const BULK_CHANGE_ACTIVITY_OWNER_REQUEST = 'BULK_CHANGE_ACTIVITY_OWNER_REQUEST';
